<template>
  <div class="py-4 container-fluid">
    <div class="text-end mb-2">
      <span class="text-white">{{ timestamp }}</span>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-12" v-if="getMenu.includes('Purchase Order')">
            <router-link to="/purchase-order">
              <card
                title="Purchase Order"
                :value="po_amount"
                iconClass="ni ni-credit-card"
                iconBackground="bg-gradient-primary"
                directionReverse
              ></card>
            </router-link>
          </div>
          <div class="col-lg-4 col-md-6 col-12" v-if="getMenu.includes('Request For Quotation')">
            <router-link to="/rfq">
              <card
                title="RFQ"
                :value="rfq_amount"
                iconClass="ni ni-single-copy-04"
                iconBackground="bg-gradient-danger"
                directionReverse
              >
            </card>
            </router-link>
          </div>
          <div class="col-lg-4 col-md-6 col-12" v-if="getMenu.includes('Certificate of Invoice')">
            <router-link to="/certificate">
              <cardDetail
                title="Certificate Invoice"
                :value="certificate_amount"
                iconClass="ni ni-paper-diploma"
                iconBackground="bg-gradient-warning"
                detailTitle="Paid :"
                :detailValue="certificate_paid_amount"
                detailStyle="text-success fw-bold"
                detailSecondTitle="Pending Payment :"
                :detailSecondValue="certificate_nonpaid_amount"
                detailSecondStyle="text-warning"
                directionReverse
              ></cardDetail>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-lg mb-lg">
            <div class="card z-index-2">
              <gradient-line-chart />
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-4 mb-lg-0 mb-4" v-if="getMenu.includes('Quality Performance')">
            <div class="card h-100">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2 align-self-center">Quality Performance</h6>
                  <router-link to="/qpr">
                    <button class="btn btn-link btn-xs" v-if="qpr_list.length > 0">View all</button>
                  </router-link>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="(qpr, index) in qpr_list" :key="index">
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <p class="mb-0 text-xs font-weight-bold">#</p>
                            <router-link :to="'/qpr/' + qpr.id" class="text-xs text-primary font-weight-bold mb-0">
                              <h6 class="mb-0 text-sm text-primary">{{ qpr.name }}</h6>
                            </router-link>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <p class="mb-0 text-xs font-weight-bold">Issue Date:</p>
                            <h6 class="mb-0 text-sm">{{ qpr.issue_date }}</h6>
                          </div>
                        </div>
                      </td>
                      <!-- <td class="text-sm align-middle">
                        <div>
                          <p class="mb-0 text-xs font-weight-bold">Product Name:</p>
                          <h6 class="mb-0 text-sm">{{ qpr.product_name }}</h6>
                        </div>
                      </td> -->
                      <td class="text-sm align-middle">
                        <div>
                          <p class="mb-0 text-xs font-weight-bold">Classification:</p>
                          <argon-badge 
                            :variant="qpr.drawback_classification === 'FATAL' ? 'gradient' : ''" 
                            :color="qpr.drawback_classification === 'FATAL' ? 'danger' : 
                                    qpr.drawback_classification === 'HEAVY' ? 'warning' : 
                                    qpr.drawback_classification === 'LIGHT' ? 'secondary' : ''"
                            size="sm">{{ qpr.drawback_classification }}</argon-badge>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!qpr_list.length > 0 && !loading"/>
            </div>
          </div>
          <div class="col-lg-4" v-if="getMenu.includes('Forecast Monthly')">
            <div class="card h-100">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2 align-self-center">Forecast Monthly</h6>
                  <router-link to="/forecast-monthly">
                    <button class="btn btn-link btn-xs" v-if="forecast.length > 0">View all</button>
                  </router-link>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="(line, index) in forecast" :key="index">
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <p class="mb-0 text-xs font-weight-bold">#:</p>
                            <router-link :to="'/forecast-monthly/' + line.id" class="text-xs text-primary font-weight-bold mb-0">
                              <h6 class="mb-0 text-sm text-primary">{{ line.name }}</h6>
                            </router-link>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <p class="mb-0 text-xs font-weight-bold">Production Month:</p>
                            <h6 class="mb-0 text-sm">{{ line.po_month }} {{ line.po_year }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <p class="mb-0 text-xs font-weight-bold">Status:</p>
                            <h6 class="mb-0 text-sm">{{ line.state }}</h6>
                          </div>
                        </div>
                      </td>
                      <!-- <td class="text-sm align-middle">
                        <div>
                          <p class="mb-0 text-xs font-weight-bold">PO Released:</p>
                          <i class="fa fa-download" aria-hidden="true"></i> Download
                        </div>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!forecast.length > 0 && !loading"/>
            </div>
          </div>
          <div class="col-lg-4" v-if="getMenu.includes('Announcement')">
            <div class="card h-100">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2 align-self-center">Announcements</h6>
                  <router-link to="/announcement">
                    <button class="btn btn-link btn-xs" v-if="announcements.length > 0">View all</button>
                  </router-link>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Title</th>
                      <th>Date</th>
                      <th>From</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(line, index) in announcements" :key="index">
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <router-link :to="'/announcement/' + line.id" class="text-xs text-primary font-weight-bold mb-0">
                              <h6 class="mb-0 text-sm text-primary">{{ line.name }}</h6>
                            </router-link>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <router-link :to="'/announcement/' + line.id" class="text-xs text-primary font-weight-bold mb-0">
                              <h6 class="mb-0 text-sm text-primary">{{ line.title }}</h6>
                            </router-link>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <h6 class="mb-0 text-sm">{{ line.date_announcement }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <h6 class="mb-0 text-sm">{{ line.department }}</h6>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!announcements.length > 0 && !loading"/>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-6 mb-lg-0 mb-4" v-if="getMenu.includes('Daily Delivery')">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2 align-self-center">Daily Delivery</h6>
                  <router-link to="/delivery">
                    <button class="btn btn-link btn-xs" v-if="delivery.length > 0">View all</button>
                  </router-link>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="(line, index) in delivery" :key="index">
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <p class="mb-0 text-xs font-weight-bold">#</p>
                            <router-link :to="'/delivery/' + line.id" class="text-xs text-primary font-weight-bold mb-0">
                              <h6 class="mb-0 text-sm text-primary">{{ line.name }}</h6>
                            </router-link>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <p class="mb-0 text-xs font-weight-bold">Month:</p>
                            <h6 class="mb-0 text-sm">{{ line.month }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div>
                          <p class="mb-0 text-xs font-weight-bold">Year:</p>
                          <h6 class="mb-0 text-sm">{{ line.year }}</h6>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!delivery.length > 0 && !loading"/>
            </div>
          </div>
          <div class="col-lg-6 mb-lg-0 mb-4" v-if="getMenu.includes('Kanban')">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2 align-self-center">Kanban</h6>
                  <router-link to="/kanban">
                    <button class="btn btn-link btn-xs" v-if="kanban.length > 0">View all</button>
                  </router-link>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                  <tbody>
                    <tr v-for="(line, index) in kanban" :key="index">
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <p class="mb-0 text-xs font-weight-bold">#</p>
                            <router-link :to="'/kanban/' + line.id" class="text-xs text-primary font-weight-bold mb-0">
                              <h6 class="mb-0 text-sm text-primary">{{ line.name }}</h6>
                            </router-link>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            <p class="mb-0 text-xs font-weight-bold">Total Kanban:</p>
                            <h6 class="mb-0 text-sm">{{ line.total_kanban }}</h6>
                          </div>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div>
                          <p class="mb-0 text-xs font-weight-bold">Delivery Date:</p>
                          <h6 class="mb-0 text-sm">{{ line.delivery_date }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div>
                          <p class="mb-0 text-xs font-weight-bold">Delivery Time:</p>
                          <h6 class="mb-0 text-sm">{{ line.delivery_time }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div>
                          <p class="mb-0 text-xs font-weight-bold">Expected Date:</p>
                          <h6 class="mb-0 text-sm">{{ line.expected_date }}</h6>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!kanban.length > 0 && !loading"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import CardDetail from "@/examples/Cards/CardDetail.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import EmptyState from "./components/EmptyState.vue";
const endpoint = require("../router/endpoint");

export default {
  name: "dashboard-default",
  data() {
    return {
      po_amount: "Rp 0",
      rfq_amount: "Rp 0",
      certificate_amount: "Rp 0",
      certificate_paid_amount: "Rp 0",
      certificate_nonpaid_amount: "Rp 0",
      qpr_list: [],
      forecast: [],
      announcements: [],
      delivery: [],
      kanban: [],
      loading: false,
      timestamp: null
    };
  },
  components: {
    Card,
    CardDetail,
    EmptyState,
    GradientLineChart,
    ArgonBadge
  },
  computed: {
    getMenu() {
      var result = []
      var menus = JSON.parse(localStorage.getItem('menu'))
      if (menus) {
        if (menus.data) {
          menus.data.forEach(item => {
            result.push(item.menu)  
          });
        }
      }
      return result
    }
  },
  methods: {
    getPO() {
      this.po_list = [];
      this.axios
        .post(
          endpoint.PO_LIST,
          {
            partner_id: localStorage.getItem("partner_id"),
            // number: this.search.po_number,
            // po_start_date: po_daterange.length > 0 ? po_daterange[0] : '',
            // po_end_date: po_daterange.length > 1 ? po_daterange[1] : '',
            // delivery_start_date: delivery_daterange.length > 0 ? delivery_daterange[0] : '',
            // delivery_end_date: delivery_daterange.length > 1 ? delivery_daterange[1] : '',
            limit: 0,
            offset: 0
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            var total = 0;
            response.data.data.forEach((po) => {
              total =
                total +
                parseFloat(
                  po.amount_total.replace("Rp", "").replaceAll(",", "")
                );
            });
            this.po_amount = "Rp " + total.toLocaleString();
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: "error",
                title: "Warning",
                text: response.data.message
              });
            }
          }
          this.loading = false;
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: "Error",
            text: e.response.data.message
          });
          this.loading = false;
        });
    },
    getRFQ() {
      this.axios
        .post(
          endpoint.RFQ_LIST,
          {
            // rfq_number: this.search.rfq_number,
            // date_start: rfq_date.length > 0 ? rfq_date[0] : null,
            // date_end: rfq_date.length > 1 ? rfq_date[1] : null,
            partner_id: localStorage.getItem("partner_id"),
            limit: 0,
            offset: 0
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            var total = 0;
            response.data.data.forEach((rfq) => {
              total = total + parseFloat(rfq.amount_total.replace("Rp", "").replaceAll(",", ""));
            });
            this.rfq_amount = "Rp " + total.toLocaleString();
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: "error",
                title: "Warning",
                text: response.data.message
              });
            }
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$notify({
            type: "error",
            title: "Error",
            text: e.response.data.message
          });
          this.loading = false;
        });
    },
    getCertificateDashboard() {
      const values = {
        partner_id: localStorage.getItem("partner_id")
      };
      this.axios
        .post(endpoint.CERTIFICATE_DASHBOARD, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        })
        .then((response) => {
          if (response.data.response_code === "0000") {
            var dashboard_cert_invoice = null;
            dashboard_cert_invoice = response.data.data;
            console.log(dashboard_cert_invoice)
            console.log(dashboard_cert_invoice.total_amount)
            console.log(dashboard_cert_invoice)
            this.certificate_amount = "Rp " + dashboard_cert_invoice.total_amount.toLocaleString();
            this.certificate_paid_amount = "Rp " + dashboard_cert_invoice.total_amount_paid.toLocaleString();
            this.certificate_nonpaid_amount = "Rp " + dashboard_cert_invoice.total_amount_nonpaid.toLocaleString();
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: "warn",
                title: "Warning",
                text: response.data.message
              });
            }
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
            type: "error",
            title: "Something went wrong!",
            text: e.response.data.message
          });
        });
    },
    getCertificate() {
      const values = {
        // certificate_number: this.search.certificate_number,
        // invoice_number: this.search.invoice_number,
        // invoice_start_date: invoice_date.length > 0 ? invoice_date[0] : null,
        // invoice_end_date: invoice_date.length > 1 ? invoice_date[1] : null,
        // faktur_number: this.search.faktur_number,
        // faktur_start_date: faktur_date.length > 0 ? faktur_date[0] : null,
        // faktur_end_date: faktur_date.length > 1 ? faktur_date[1] : null,
        partner_id: localStorage.getItem("partner_id"),
        limit: 0,
        offset: 0
      };
      this.axios
        .post(endpoint.CERTIFICATE_LIST, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        })
        .then((response) => {
          if (response.data.response_code === "0000") {
            var total = 0;
            response.data.data.forEach((certificate) => {
              total = total + parseFloat(certificate.amount_total.replace("Rp", "").replaceAll(",", ""));
            });
            this.certificate_amount = "Rp " + total.toLocaleString();
          } else {
            if (response.data.response_code !== "4000") {
              this.$notify({
                type: "warn",
                title: "Warning",
                text: response.data.message
              });
            }
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
            type: "error",
            title: "Something went wrong!",
            text: e.response.data.message
          });
        });
    },
    getForecast() {
      this.forecast = []
      this.axios
        .post(
          endpoint.FORECAST_LIST,
          {
            partner_id: localStorage.getItem('partner_id'),
            limit: 5,
            offset: 0,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.forecast = response.data.data;
          } else if (response.data.reponse_code === "4000") {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    getQPR() {
      this.qpr_list = []
      this.axios
      .post(
        endpoint.QPR_LIST,
        {
          partner_id: localStorage.getItem('partner_id'),
          limit: 5,
          offset: 0
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      )
      .then((response) => {
        if (response.data.response_code === "0000") {
          this.qpr_list = response.data.data;
          this.total_data = response.data.total_data
          this.current_total_data = response.data.total_data
          this.record_more = response.data.record_more
          this.current_page = response.data.current_page
          this.loading = false
        } else {
          if (response.data.response_code !== "4000"){
            this.$notify({
              type: 'error',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        }
      })
      .catch((e) => {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.response.data.message,
        });
        this.loading = false
      });
    },
    getAnnouncements() {
      this.announcements = []
      this.axios
        .post(
          endpoint.ANNOUNCEMENT_LIST,
          {
            partner_id: localStorage.getItem('partner_id'),
            limit: 5,
            offset: 0,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.announcements = response.data.data;
          } else if (response.data.response_code !== "4000") {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Failed',
            text: e.response.data.message,
          });
          this.loading = false;
        });
    },
    getDelivery() {
      // this.loading = true
      this.delivery = []
      // this.total_data = 0
      // this.current_total_data = 0
      // this.record_more = false
      // this.current_page = 0
      // const getMonthrange = this.getDate(this.search.month)
      const values = {
        // date_start: getMonthrange.length > 0 ? getMonthrange[0] : null,
        // date_end: getMonthrange.length > 1 ? getMonthrange[1] : null,
        partner_id: localStorage.getItem("partner_id"),
        limit: 5,
        offset: 0
      }
      this.axios
        .post(
          endpoint.DELIVERY_LIST,
          values,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.delivery = response.data.data;
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'warn',
                title: 'Warning',
                text: response.data.message,
              });
            }
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false;
          this.$notify({
              type: 'error',
              title: 'Something went wrong!',
              text: e.response.data.message,
            });
        });
    },
    getKanban() {
      this.kanban = []
      this.axios
        .post(
          endpoint.DN_LIST,
          {
            partner_id: localStorage.getItem('partner_id'),
            limit: 5,
            offset: 0,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          }
        )
        .then((response) => {
          if (response.data.response_code === "0000") {
            this.kanban = response.data.data;
          } else if (response.data.reponse_code === "4000") {
            this.$notify({
              type: 'warn',
              title: 'Warning',
              text: response.data.message,
            });
          }
          this.loading = false
        })
        .catch((e) => {
          this.$notify({
              type: 'error',
              title: 'Failed',
              text: e.response.data.message,
            });
          this.loading = false;
        });
    },
    getNow: function() {
        const today = new Date();
        const date = today.toLocaleString('en-us',{month:'long', year:'numeric', day:'numeric'})
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const dateTime = date +' '+ time;
        this.timestamp = dateTime;
    }
  },
  created() {
      setInterval(this.getNow, 1000);
  },
  mounted() {
    this.getPO();
    this.getRFQ();
    // this.getCertificate();
    this.getForecast();
    this.getQPR();
    this.getAnnouncements();
    this.getDelivery();
    this.getKanban();
    this.getCertificateDashboard();
  }
};
</script>
